import React from 'react';
import { TFunction } from 'react-i18next';

import { MobileView } from 'editor/src/store/app/types';

import IconPageView from '../Icon/IconPageView';
import IconSpreadView from '../Icon/IconSpreadView';

import styles from './index.module.scss';

interface OnChangeCallback {
  (mode: MobileView): void;
}

function getToggleOptions(onChangeCallback: OnChangeCallback, t: TFunction<'translation', undefined>) {
  return [
    {
      content: (
        <div className={styles.toggleOption}>
          <IconSpreadView />
          <div>{t('All pages')}</div>
        </div>
      ),
      value: 'spreads',
      callback: () => onChangeCallback('spreads'),
    },
    {
      content: (
        <div className={styles.toggleOption}>
          <IconPageView />
          <div>{t('Page')}</div>
        </div>
      ),
      value: 'canvas',
      callback: () => onChangeCallback('canvas'),
    },
  ];
}

export default getToggleOptions;
